/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportConvenienceChainsV2MutationRequest,
  ExportConvenienceChainsV2MutationResponse,
  ExportConvenienceChainsV2400,
  ExportConvenienceChainsV2500,
} from '../types/ExportConvenienceChainsV2'

function getExportConvenienceChainsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/places/convenience/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async convenience chains export.
 * @summary Start an async convenience chains export
 * {@link /api/v1/places/convenience/export/v2/}
 */
export async function exportConvenienceChainsV2(
  data: ExportConvenienceChainsV2MutationRequest,
  config: Partial<RequestConfig<ExportConvenienceChainsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportConvenienceChainsV2MutationResponse,
    ResponseErrorConfig<
      ExportConvenienceChainsV2400 | ExportConvenienceChainsV2500
    >,
    ExportConvenienceChainsV2MutationRequest
  >({
    method: 'POST',
    url: getExportConvenienceChainsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
